export default function EnterIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.5 0.5C0.223858 0.5 0 0.723858 0 1V5.8C0 7.18071 1.11929 8.3 2.5 8.3H12.2929L8.94645 11.6464C8.75118 11.8417 8.75118 12.1583 8.94645 12.3536C9.14171 12.5488 9.45829 12.5488 9.65355 12.3536L13.8536 8.15355C14.0488 7.95829 14.0488 7.64171 13.8536 7.44645L9.85355 3.44645C9.65829 3.25118 9.34171 3.25118 9.14645 3.44645C8.95118 3.64171 8.95118 3.95829 9.14645 4.15355L12.2929 7.3H2.5C1.67157 7.3 1 6.62843 1 5.8V1C1 0.723858 0.776142 0.5 0.5 0.5Z"
        fill="#ADB5BD"
      />
    </svg>
  );
}
